import { Box } from "@outschool/backpack";
import { TFunction, useTranslation } from "@outschool/localization";
import { TrackedButton } from "@outschool/ui-components-shared";
import * as _ from "lodash";
import React from "react";

import { TabNames, TabValue } from "../types";

export default function TabHeader({
  tabs = [],
  currentTab,
  handleTabClick,
  keyPrefix
}: {
  tabs: TabValue[];
  currentTab: TabValue | null;
  handleTabClick: (tab: TabValue) => void;
  keyPrefix: string;
}) {
  const { t } = useTranslation(
    "client\\components\\parentDashboard\\tabs\\TabHeader"
  );

  return (
    <Box
      sx={{
        display: "flex",
        padding: "20px",
        paddingBottom: 0,
        gap: "3rem",
        overflowX: "scroll",
        backgroundColor: "common.white",
        boxShadow: "0 5px 5px rgba(0, 0, 0, 0.25)",

        "::-webkit-scrollbar": {
          display: "none"
        },

        scrollbarWidth: "none"
      }}
    >
      {tabs.map((tab, index) => (
        <TrackedButton
          onClick={() => {
            handleTabClick(tab);
          }}
          variant="link"
          sx={{
            paddingBottom: "12px !important",
            color: `${
              _.isEqual(currentTab, tab) ? "#4B01D4" : "#262626"
            } !important`,
            borderBottom: `2px solid ${
              _.isEqual(currentTab, tab) ? "#4B01D4" : "transparent"
            } !important`,
            textDecoration: "none !important"
          }}
          key={`${keyPrefix}-${tab.name}`}
          trackingName="for_you_tabs"
          trackingUniqueId={tab.name}
          trackingSharedProperties={{
            order: index,
            current_tab: currentTab?.name
          }}
        >
          {getTranslatedTabName(tab.name, t)}
        </TrackedButton>
      ))}
    </Box>
  );
}

function getTranslatedTabName(tabName: string, t: TFunction): string {
  switch (tabName) {
    case TabNames.Favorites:
      return t("Favorites");
    case TabNames.Recent:
      return t("Recent");
    case TabNames.Trending:
      return t("Trending");
    // otherwise it's a learner name - don't translate
    default:
      return tabName;
  }
}
